import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router} from '@angular/router';
import {Document} from '../documents/document';
import {PersonLogin} from '../person/person-login';
import {DocumentService} from '../services/document-service';
import {PersonLoginService} from '../services/person-login-service';
import {StringUtils} from '../utils/string-utils';
import {FileUtils} from "../utils/file-utils";
import {MatProgressSpinner} from '@angular/material/progress-spinner';

import {BrandID} from "../enums/brand-id";
import {firstValueFrom} from "rxjs";

@Component({
    selector: 'training',
    templateUrl: './training.component.html',
    styleUrls: ['./training.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner]
})
export class TrainingComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly documentService = inject(DocumentService);
  private readonly router = inject(Router);


  private personLogin!: PersonLogin;
  public readonly documents = signal<Document[]>(undefined!);
  public readonly isBusy = signal<boolean>(undefined!);
  public readonly errorMessage = signal<string>(undefined!);
  public readonly searchComplete = signal<boolean>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      if (!this.personLogin) {
        this.router.navigate(['main']);
      } else {
        this.search();
      }
    }
  }

  public search(): void {
    this.clearStatus();
    this.loadAllTrainingDocs().then(results => {
      this.documents.set(results);
      this.isBusy.set(false);
      this.searchComplete.set(true);
    }, error => this.handleError(error));
  }

  private async loadAllTrainingDocs(): Promise<Document[]> {
    const trainingDocs: Document[] = [];
    for (const brandId of this.personLoginService.getBrandIDs()) {
      const brandDocs: Document[] = await firstValueFrom<Document[]>(this.documentService.getTrainingDocuments(BrandID[brandId]));
      trainingDocs.push(...brandDocs);
    }
    return trainingDocs;
  }

  public download(document: Document) {
    this.isBusy.set(true);
    this.errorMessage.set(null!);
    this.documentService.downloadTrainingDocument(document).subscribe(response => {
      this.isBusy.set(false);
      FileUtils.downloadFile(response, document.fileName);
    }, error => {
      this.handleError(error);
    });
  }

  private clearStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(null!);
    this.searchComplete.set(false);
    this.documents.set(null!);
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

}
